'use client'
import React from 'react'
import Image from 'next/image'
import { getFileUrl } from '@/utils'
import Link from 'next/link'
import { Button } from 'react-bootstrap'
import BlogDefault from '@/assets/footer-mb.png'
import styles from '../page.module.scss'

const _topCategoryItem = ['ms_tmt_bars', 'aluminium_billets', 'mild_steel_scrap', 'cr_coils', 'bitumen']

const TopCategory = ({ categoryData }) => {
	const TopCategoryItem = categoryData?.filter((item) => _topCategoryItem?.includes(item?.category_id))
	return (
		<div className={`d-flex col-row gap-2 ${styles.itemIconWapper}`}>
			{TopCategoryItem?.map((item, index) => {
				const _imageUrl = item?.image?.includes('http') ? item?.image : getFileUrl + item?.image
				return (
					<Link href={`/product-details/${item?.slug}`} key={index}>
						<Button variant='outline-secondary' className={`${styles.itemIcon} d-flex align-items-end gap-2`}>
							<Image
								src={_imageUrl}
								width={15}
								height={15}
								alt={item?.category_name}
								onError={(e) => {
									e.target.src = `${BlogDefault.src}`
								}}
							/>
							<span>{item?.category_name}</span>
						</Button>
					</Link>
				)
			})}
		</div>
	)
}

export default TopCategory
